import { connect } from 'react-redux';
import { createCommission, updateCommission, } from '../redux/commissions/actionCreators';
export default connect(function (state) { return ({}); }, { updateCommission: updateCommission, createCommission: createCommission });
//# sourceMappingURL=CommissionEditPopup.container.js.map